import React, { PureComponent } from 'react';

import { getHotkeyByType, getHotkeyUI } from '../utils/doc-hotkeys';
import { NODE_TYPES, DISABLED_NODES_WHEN_COLLAPSED, getNodeByType } from '../utils/doc-editor';

import { logError } from 'shared-services/logger-service';

import Tooltip from './tooltip';

const DocMenuItem = ({ type, active, disabled, horizontal, disabledWhenCollapsed, onClick }) => {
    const handleClick = event => {
        event.preventDefault();
        if (disabled) {
            return;
        }

        onClick && onClick(type);
    }

    const node = getNodeByType(type);

    return (
        <div className={'doc-menu-item' + (active ? ' active' : '') + (disabled ? ' disabled' : '')} onMouseDown={handleClick}>
            {
                horizontal ? (
                    <Tooltip disabled={disabled && !disabledWhenCollapsed} tooltip={disabled && disabledWhenCollapsed ? (
                            <span className="item-label">Highlight text to {node.label.toLowerCase()}</span>
                        ) : (
                            <React.Fragment>
                                <span className="item-label">{node.label}</span>

                                { !disabled ? <span className="item-shortcut">&nbsp;{getHotkeyUI(getHotkeyByType(type))}</span> : null }

                            </React.Fragment>
                    )}>
                        <div className="item-icon">{node.icon}</div>
                    </Tooltip>
                ) : (   
                    <React.Fragment>
                        <div className="item-icon">{node.icon}</div>

                        <div className="item-label">{node.label}</div>

                        <div className="item-shortcut">{getHotkeyUI(getHotkeyByType(type))}</div>
                    </React.Fragment>
                )
            }
        </div>
    )
}

export default class DocMenu extends PureComponent {
    static defaultProps = {
        disabledItems: []
    }

    isItemActive(type) {
        try {
            if (!this.props.value || !this.props.editor) {
                return false;
            }

            // TODO

            if (type === NODE_TYPES.table && 'isSelectionInTable' in this.props.editor) {
                return this.props.editor.isSelectionInTable();
            }

            const node = getNodeByType(type);
            const { group } = node;

            if (group === 'mark' && this.props.value.activeMarks) {
                return this.props.value.activeMarks.some(mark => mark.type === type);
            }

            if (group === 'block' && this.props.value.blocks) {
                return this.props.value.blocks.some(node => node.type === type);
            }
        } catch (error) {
            logError('nifty-doc', error);
        }
    }

    isItemDisabled(type) {
        if (this.props.disabledItems.includes(type)) {
            return true;
        }

        if (this.props.isCollapsed && DISABLED_NODES_WHEN_COLLAPSED.includes(type)) {
            return true;
        }

        if (!this.props.activeItems) {
            return false;
        }

        const activeItems = [].concat(...this.props.activeItems);

        return !activeItems.includes(type);
    }

    render() {
        return (
            <div className={'doc-menu' + (this.props.horizontal ? ' horizontal' : '')}>
                {
                    this.props.items.map((group, index) => (
                        <div key={index} className="doc-menu-group">
                            {
                                group.map((type, index) => <DocMenuItem
                                    key={index}
                                    type={type}
                                    active={this.isItemActive(type)}
                                    disabled={this.isItemDisabled(type)}
                                    disabledWhenCollapsed={DISABLED_NODES_WHEN_COLLAPSED.includes(type)}
                                    horizontal={this.props.horizontal}
                                    onClick={this.props.onAction}
                                />)
                            }
                        </div>
                    ))
                }
            </div>
        )
    }
}
